import * as CONSTANTS from "./constants";

export const updateVoteData = (data = {}, opkomstRest, opkomstJeugd) => {
  const stemmenRest =
    opkomstRest / 100 * (data.kiesgerechtigden - data.kiesgerechtigdenJeugd);
  const stemmenJeugd = opkomstJeugd / 100 * data.kiesgerechtigdenJeugd;
  const stemmenTotaal = stemmenRest + stemmenJeugd;
  const kiesdeler = stemmenTotaal / data.zetels;
  const zetelsJeugd = stemmenJeugd / kiesdeler;
  const zetelsRest = stemmenRest / kiesdeler;

  return {
    type: CONSTANTS.UPDATE_VOTE_DATA,
    payload: {
      opkomstJeugd,
      opkomstRest,
      stemmenJeugd,
      stemmenRest,
      stemmenTotaal,
      kiesdeler,
      zetelsJeugd,
      zetelsRest
    }
  };
};



// WEBPACK FOOTER //
// ./src/services/votedata/actions.js